import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export type FileRowSkeletonProps = {
  className?: string
}

export function FileRowSkeleton({ className }: FileRowSkeletonProps) {
  return (
    <li
      className={cn(
        'flex flex-col gap-1 py-3 sm:flex-row sm:items-center sm:justify-between',
        className,
      )}
      aria-hidden
    >
      <div className="min-w-0 flex-1 space-y-1.5">
        <Skeleton className="h-4 w-2/3 max-w-xs" />
        <Skeleton className="h-3 w-24" />
      </div>
      <Skeleton className="size-8 shrink-0 rounded-md" />
    </li>
  )
}

export type FileListSkeletonProps = {
  count?: number
  ariaLabel?: string
  className?: string
}

export function FileListSkeleton({
  count = 4,
  ariaLabel = 'Loading files',
  className,
}: FileListSkeletonProps) {
  return (
    <ul
      className={cn('divide-y divide-border', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      {Array.from({ length: count }).map((_, index) => (
        <FileRowSkeleton key={index} />
      ))}
    </ul>
  )
}
